import React, { useState } from "react";
import { trans } from "../../../helpers/index";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import ErrorModal from "../../Fragments/ErrorModal";
import { Link } from "react-router-dom";
import config from "../../../baseConfig";
import { ArmenianFlagConst } from "../../UIComponents/UIComponents";
import Tab from "../../Fragments/Tab";

function StepOne(props) {
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [formResponse, setFormResponse] = useState("");

  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [touched, setTouched] = useState(false);
  const [phoneValue, setPhoneValue] = useState(
    props.forgotConfig.userName || ""
  );
  const [emailValue, setEmailValue] = useState(
    props.forgotConfig.userName || ""
  );

  const phoneRegex = /^[1-9]\d{7}$/;
  const emailRegex = /^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/;

  const validateForm = () => {
    if (currentTabIndex === 0) {
      const phone = phoneValue.trim();
      return phone.length > 0 && phoneRegex.test(phone);
    } else {
      const email = emailValue.trim();
      return email.length > 0 && emailRegex.test(email);
    }
  };

  const errorModal = () => {
    if (!showErrorModal) return null;
    return (
      <ErrorModal
        title={trans(props.trans, "error.modal.title")}
        description={trans(props.trans, "error.modal.description")}
        action_text={trans(props.trans, "error.modal.action_text")}
      />
    );
  };

  const reSendData = () => {
    setButtonDisabled(true);
    ApiManager.getRequest({}, "/csrf-token").then(
      (resolve) => {
        props.setTokenAction(resolve.data);
        sendData();
      },
      () => {
        setShowErrorModal(true);
      }
    );
  };

  const sendData = () => {
    setButtonDisabled(true);

    const currentValue = currentTabIndex === 0 ? phoneValue : emailValue;
    const type = currentTabIndex === 0 ? "mob" : "email";

    ApiManager.postRequest(
      {
        msisdn:
          currentTabIndex === 0 ? currentValue.replace(/^\+374|^0/g, "") : "",
        email: currentTabIndex === 1 ? currentValue : "",
        _token: props.csrf_token.data,
      },
      "/forgot-password/" + type + "/request"
    ).then(
      (resolve) => {
        setButtonDisabled(false);
        setFormResponse(resolve.data);

        if (resolve.data.hasOwnProperty("token")) {
          props.updateParentState({
            step: 2,
            token: resolve.data.token,
            mobileTimeLife: resolve.data.data.time,
            type: type,
          });
        } else if (resolve.data.status === "CSRF_TOKEN_MISMATCH") {
          window.location.reload();
          reSendData();
        }
      },
      () => {
        setShowErrorModal(true);
      }
    );
  };

  let errorUserNameClass = "",
    errorUserNameBox = "",
    errorBox = "";

  if (formResponse !== "") {
    if (formResponse.status === "INVALID_DATA") {
      if (formResponse.errors.hasOwnProperty("msisdn")) {
        errorUserNameClass = " form-error";
        errorUserNameBox = (
          <div className="form-error-text fs11">
            {formResponse.errors.msisdn}
          </div>
        );
      }
      if (formResponse.errors.hasOwnProperty("email")) {
        errorUserNameClass = " form-error";
        errorUserNameBox = (
          <div className="form-error-text fs11">
            {formResponse.errors.email}
          </div>
        );
      }
      if (formResponse.errors.hasOwnProperty("message")) {
        errorUserNameClass = " form-error";
        errorUserNameBox = (
          <div className="form-error-text fs11">
            {formResponse.errors.message}
          </div>
        );
      }
    }

    if (formResponse.status === "ERROR") {
      errorBox = (
        <FormMiddlewareError
          message={formResponse.message}
          trans={props.trans}
        />
      );
    }
  }

  const phoneEmpty = phoneValue.trim().length === 0;
  const emailEmpty = emailValue.trim().length === 0;

  const showPhoneError =
    touched &&
    currentTabIndex === 0 &&
    !phoneEmpty &&
    !phoneRegex.test(phoneValue.trim());
  const showEmailError =
    touched &&
    currentTabIndex === 1 &&
    !emailEmpty &&
    !emailRegex.test(emailValue.trim());

  return (
    <div className="form">
      <form
        action="#"
        method="post"
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
          setTouched(true);

          if (!validateForm()) {
            return;
          }
          sendData();
        }}
      >
        <Tab
          items={[
            {
              title: trans(props.trans, "auth.number.title"),
              content: (
                <>
                  <div className={`form__form-box${errorUserNameClass}`}>
                    <label className="form__label db fs11" htmlFor="tel-number">
                      {trans(props.trans, "b2b.login_form.fullname.label")}
                    </label>
                    <div
                      className="form__field-out"
                      style={{ display: "flex" }}
                    >
                      <ArmenianFlagConst />
                      <input
                        className="form__field fs13"
                        id="tel-number"
                        name="tel-number"
                        disabled={buttonDisabled}
                        style={{
                          border: "none",
                          borderRadius: "0",
                          borderBottom: "1px solid #ccc",
                        }}
                        type="text"
                        placeholder={trans(
                          props.trans,
                          "auth.login.number.placeholder"
                        )}
                        onChange={(event) => {
                          const value = event.target.value.trim();
                          setPhoneValue(value);
                          // Still update parent state to maintain compatibility
                          props.updateParentState({
                            userName: value,
                          });
                        }}
                        onFocus={() => setTouched(false)}
                        onBlur={() => setTouched(true)}
                        value={phoneValue}
                      />
                    </div>
                    {errorUserNameBox}

                    {touched && phoneEmpty && (
                      <div
                        className="form-error-text fs11"
                        style={{ marginTop: "5px", color: "red" }}
                      >
                        {trans(props.trans, "field.required")}{" "}
                      </div>
                    )}
                    {showPhoneError && (
                      <div
                        className="form-error-text fs11"
                        style={{ marginTop: "5px", color: "red" }}
                      >
                        {trans(props.trans, "auth.login.validation.number")}
                      </div>
                    )}
                  </div>
                </>
              ),
              clickCallback: () => {
                setTouched(false);
                setCurrentTabIndex(0);
                props.updateParentState({
                  currentTabIndex: 0,
                  userName: phoneValue,
                });
                setFormResponse("");
              },
            },
            {
              title: trans(props.trans, "auth.email.title"),
              content: (
                <>
                  <div className={`form__form-box${errorUserNameClass}`}>
                    <label
                      className="form__label db fs11"
                      htmlFor="email-field"
                    >
                      {trans(props.trans, "b2b.forgot_password.email_label")}
                    </label>
                    <div
                      className="form__field-out"
                      style={{ display: "flex" }}
                    >
                      <input
                        disabled={buttonDisabled}
                        className="form__field fs13"
                        id="email-field"
                        name="email-field"
                        type="email"
                        placeholder={trans(
                          props.trans,
                          "auth.login.email.placeholder"
                        )}
                        onChange={(event) => {
                          const value = event.target.value.trim();
                          setEmailValue(value);
                          props.updateParentState({
                            userName: value,
                          });
                        }}
                        onFocus={() => setTouched(false)}
                        onBlur={() => setTouched(true)}
                        value={emailValue}
                      />
                    </div>
                    {errorUserNameBox}

                    {touched && emailEmpty && (
                      <div
                        className="form-error-text fs11"
                        style={{ marginTop: "5px", color: "red" }}
                      >
                        {trans(props.trans, "field.required")}
                      </div>
                    )}
                    {showEmailError && (
                      <div
                        className="form-error-text fs11"
                        style={{ marginTop: "5px", color: "red" }}
                      >
                        {trans(props.trans, "auth.login.validation.email")}
                      </div>
                    )}
                  </div>
                </>
              ),
              clickCallback: () => {
                setTouched(false);
                setCurrentTabIndex(1);
                setFormResponse("");
                props.updateParentState({
                  currentTabIndex: 1,
                  userName: emailValue,
                });
              },
            },
          ]}
          index={
            window.location.hash.replace("#", "") === "b2b" ? 1 : props.tabIndex
          }
        />

        {errorBox}

        <button
          className={`form__registration-btn btn btn--with-space btn--yellow fs17${
            buttonDisabled ? " btn--loading" : ""
          }`}
          type="submit"
          disabled={buttonDisabled}
        >
          {trans(props.trans, "auth.forgot.password.button.title")}
        </button>

        <Link
          className="form__submit-btn btn btn--white db fs17"
          to={config.urlPrefix}
        >
          {trans(props.trans, "auth.forgot.password.button.cancel")}
        </Link>
      </form>

      {errorModal()}
    </div>
  );
}

export default StepOne;
